// 初始化数据
const modal = {
  exportLoading: false,
  modalSimple: false, //显示修改现货库存弹框
  stockNum: 0, //库存数量
  currentQty: 0,
  productCode: '', //商品编码
  searchResult: [], //查询结果数据
  searchParams: {}, // 搜索传值
  saveQuery: {
    // cooperationStatus: 2,
  }, //暂保存传值
  total: 0, // 查询总数
  page: 1, // 当前页码
  size: 10, // 当前分页数
  tableLoading: false, // 列表loading
  action: '', //是否是编辑或者新增
  isShowSearch: false, //是否显示高级查询
  selectedRowKeys: [], //选择的行
  tabType: '1', //当前列表状态 0在售商品 1商品资料
  bbcProductListParameters: {
    //bbc供应商商品列表
  },
  vagueSearch: {},
  vagueSearchResult: [], //模糊搜索查询结果
  stockSearchResult: {
    //库存修改传值
    currentQty: 0,
    productCode: '',
  },
  stockAlertResult: {}, //库存提醒查询结果
  tabsData: [
    {
      name: '可售商品',
      key: '0',
      number: 0,
    },
    {
      name: '待售商品',
      key: '1',
      number: 0,
    },
  ], //tab标签
};
export default modal;
